import { Box, Button, Flex, IconAlertCircle, Text } from '@cmpsr/components';
import useNotificationsController from './notifications.controller';
import { FollowUpNotification } from '@/repositories/notification.repository';

export default function Notifications({ notificationRef }: { notificationRef: (node: HTMLDivElement) => void }) {
  const { notification, dismissNotification } = useNotificationsController();

  if (!notification) return null;

  const { actions, question } = notification.details as FollowUpNotification;
  const followUpDetails = `${actions[0].toLowerCase()}${actions.slice(1)}`;

  let followUpMessage = '';
  switch (question) {
    case 'question_symptoms':
      followUpMessage = `We recommend that you ${followUpDetails}`;
      break;
    case 'question_genetic_results':
      followUpMessage = 'We recommend that you follow up with a doctor to discuss your genetic testing results';
      break;
    default:
      followUpMessage = 'We recommend that you follow up with a doctor to discuss your test results';
      break;
  }

  return (
    <Flex
      bgColor="alert-error-default"
      justifyContent="space-between"
      p="spacer-3"
      gap="spacer-3"
      flexWrap="wrap"
      ref={notificationRef}
    >
      <Flex>
        <Box pr="10px">
          <IconAlertCircle color="text-error" />
        </Box>
        <Box flexGrow="1">
          <Text color="text-error" variant="text-body-bold">
            FOLLOW UP ACTION NEEDED
          </Text>
          <Text color="text-error" variant="text-body-regular">
            {followUpMessage}
          </Text>
        </Box>
      </Flex>
      <Box w="212px" alignContent="center" flexBasis={{ base: '100%', lg: 'auto' }}>
        <Button w="100%" onClick={dismissNotification}>
          Mark as completed
        </Button>
      </Box>
    </Flex>
  );
}
